import React from 'react';
import MiniMarketHoursTable from './MiniMarketHoursTable';

const MiniMarketHoursLosers = ({ data }) => {
    return (
        <MiniMarketHoursTable
            type="losers"
            title="Today Losers"
            linkTo="/market-movers?tab=losers"
            data={data}
        />
    );
};

export default MiniMarketHoursLosers;